export const selectData = (state) => state.data
